<template>
  <main
    class="min-h-dvh w-full px-4 py-10 sm:py-14 flex items-center justify-center bg-gradient-to-br from-primary to-primary-darker text-color-mode-text"
    role="status"
  >
    <div class="fixed top-4 right-4 z-50 pointer-events-auto">
      <UiColorMode />
    </div>
    
    <Transition
      name="fade"
      mode="out-in"
      enter-active-class="transition-all duration-500 ease-out"
      leave-active-class="transition-all duration-300 ease-in"
      enter-from-class="opacity-0 transform scale-95"
      enter-to-class="opacity-100 transform scale-100"
      leave-from-class="opacity-100 transform scale-100"
      leave-to-class="opacity-0 transform scale-95"
    >
      <section
        class="w-full max-w-[520px] rounded-2xl bg-primary-lighter ring-1 ring-black/5 dark:ring-white/10 px-6 py-8 sm:px-10 sm:py-10"
        aria-labelledby="auth-title"
      >
        <slot />
      </section>
    </Transition>
  </main>
</template>
